import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Public Firebase web config. These values are safe to commit — they identify
// the Firebase project but don't grant write access on their own (security is
// enforced by Firebase Auth rules and by our backend verifying ID tokens).
const firebaseConfig = {
  apiKey: 'AIzaSyDYkEboNrUCGa8toj8aZxJo5LhpHuMScOI',
  authDomain: 'dynastyrep-209a1.firebaseapp.com',
  projectId: 'dynastyrep-209a1',
  storageBucket: 'dynastyrep-209a1.firebasestorage.app',
  messagingSenderId: '53794467177',
  appId: '1:53794467177:web:25f3b79b18acc5f38c61f8',
  measurementId: 'G-J8XZEMN19K',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();

// Request the basic profile scopes Google returns by default. We read name
// and picture from the ID token on first sync in the backend.
googleProvider.addScope('profile');
googleProvider.addScope('email');
